import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Card, Image } from '@themesberg/react-bootstrap';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';

export const CounterWidget = (props) => {
  const { icon, iconColor, category, title, period } = props;

  return (
    <Card border="dark" className="shadow-sm">
      <Card.Body>
        <Row className="d-block d-xl-flex align-items-center">
          <Col xl={5} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
            <div className={`icon icon-shape icon-md icon-${iconColor} rounded me-4 me-sm-0`}>
              <FontAwesomeIcon icon={icon} />
            </div>
            <div className="d-sm-none">
              <h5>{category}</h5>
              <h3 className="mb-1">{title}</h3>
            </div>
          </Col>
          <Col xs={12} xl={7} className="px-xl-0">
            <div className="d-none d-sm-block">
              <h5>{category}</h5>
              <h3 className="mb-1">{title}</h3>
            </div>
            <small>{period}</small>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export const ProfileCardWidget = (props) => {
  const { fullName, dateHired, isActive, photoUrl } = props;
  return (
    <Card border="dark" className="text-center p-0 mb-4">
      <div style={{ backgroundImage: `url(${process.env.REACT_APP_PROFILE_BANNER})` }} className="profile-cover rounded-top" />
      <Card.Body className="pb-5">
        <Card.Img
          src={photoUrl ? photoUrl : process.env.REACT_APP_DEFAULT_IMAGE}
          alt={fullName}
          className="user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4"
        />
        <Card.Title>{fullName}</Card.Title>
        <Card.Subtitle className="fw-normal">Date Hired: <b>{dateHired}</b></Card.Subtitle>
        <Card.Text className="text-gray mb-2">
          {isActive ? (
              <>
                Status: <span className="fw-normal text-success">Active</span>
              </>
            ) : (
              <>
                Status: <span className="fw-normal text-danger">In-Active</span>
              </>
            )}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export const ClientProfileCardWidget = (props) => {
  const { fullName, displayName, companyName, photoUrl } = props;
  return (
    <Card border="dark" className="text-center p-0 mb-4">
      <div style={{ backgroundImage: `url(${process.env.REACT_APP_PROFILE_BANNER})` }} className="profile-cover rounded-top" />
      <Card.Body className="pb-5">
        <Card.Img
          src={photoUrl ? photoUrl : process.env.REACT_APP_DEFAULT_IMAGE}
          alt={fullName}
          className="user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4"
        />
        <Card.Title>{fullName}</Card.Title>
        <Card.Subtitle className="fw-normal mb-3 break-long-words">Display Name: <b>{displayName}</b></Card.Subtitle>
        <Card.Subtitle className="fw-normal break-long-words">Company Name: <b>{companyName}</b></Card.Subtitle>
      </Card.Body>
    </Card>
  );
};

export const ChoosePhotoWidget = (props) => {
  const { title, photo } = props;

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">{title}</h5>
        <div className="d-xl-flex align-items-center">
          <div className="user-avatar xl-avatar">
            <Image fluid rounded src={photo} />
          </div>
          <div className="file-field">
            <div className="d-flex justify-content-xl-center ms-xl-3">
              <div className="d-flex">
                <span className="icon icon-md">
                  <FontAwesomeIcon icon={faPaperclip} className="me-3" />
                </span>
                <input type="file" />
                <div className="d-md-block text-start">
                  <div className="fw-normal text-dark mb-1">Choose Image</div>
                  <div className="text-gray small">JPG, GIF or PNG. Max size of 800K</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
